import { updateObject } from '../../shared/utility';
import {
    GET_AGENTS_START,
    GET_AGENTS_SUCCESS,
    GET_AGENTS_FAIL,
    CREATE_AGENT_START,
    CREATE_AGENT_SUCCESS,
    CREATE_AGENT_FAIL,
    GET_AGENT_DETAIL_START,
    GET_AGENT_DETAIL_SUCCESS,
    GET_AGENT_DETAIL_FAIL,
    UPDATE_AGENT_DETAIL_START,
    UPDATE_AGENT_DETAIL_SUCCESS,
    UPDATE_AGENT_DETAIL_FAIL,
    OPEN_AGENT_EDIT,
    CLOSE_AGENT_EDIT,
    OPEN_AGENT_PRODUCT_ADD,
    CLOSE_AGENT_PRODUCT_ADD,
    OPEN_AGENT_PRODUCT_EDIT,
    CLOSE_AGENT_PRODUCT_EDIT,
    SET_LAST_REPORTED_DATE,
} from '../actions/actionTypes';


const initialState = {
    error: null,
    message: null,
    loading: false,
    agents: [],
    agentDetail: {},
    agentProduct:[],
    editAgentVisible: false,
    addAgentProductVisible: false,
    editAgentProductVisible: false,
    lastReportedDate:'01-01-2222',
}

const getAgentsStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getAgentsSuccess = (state, action) => {
    return updateObject(state, { error: null, loading: false, agents: action.agents });
}

const getAgentsFail = (state, action) => {
    return updateObject(state, { error: action.error, agents: [] });
}

const createAgentStart = (state, action) => {
    return updateObject(state, { error: null, message: null, loading: true });
}

const createAgentSuccess = (state, action) => {
    return updateObject(state, { error: null, message: action.message, loading: false });
}

const createAgentFail = (state, action) => {
    return updateObject(state, { error: action.error, message: null, loading: false });
}

const getAgentDetailStart = (state, action) => {
    return updateObject(state, { error: null, message: null, loading: true });
}

const getAgentDetailSuccess = (state, action) => {
    return updateObject(state, { error: null, loading: false, agentDetail: action.agentDetail });
}

const getAgentDetailFail = (state, action) => {
    return updateObject(state, { error: action.error, message: null, loading: false });
}

const updateAgentDetailStart = (state, action) => {
    return updateObject(state, { error: null, message: null, loading: true });
}

const updateAgentDetailSuccess = (state, action) => {
    return updateObject(state, { loading: false });
}

const updateAgentDetailFail = (state, action) => {
    return updateObject(state, { loading: false });
}

const openAgentEdit = (state, action) => {
    return updateObject(state, { editAgentVisible: true });
}

const closeAgentEdit = (state, action) => {
    return updateObject(state, { editAgentVisible: false });
}

const openAgentProductAdd = (state, action) => {
    return updateObject(state, { addAgentProductVisible: true });
}

const closeAgentProductAdd = (state, action) => {
    return updateObject(state, { addAgentProductVisible: false });
}

const openAgentProductEdit=(state,action)=>{
    return updateObject(state,{editAgentProductVisible:true,agentProduct:action.agentProduct});
}

const closeAgentProductEdit=(state,action)=>{
    return updateObject(state,{editAgentProductVisible:false});
}

const setLastReportedDate=(state,action)=>{
    return updateObject(state,{lastReportedDate:action.payload});
}
const agentReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_AGENTS_START:
            return getAgentsStart(state, action);
        case GET_AGENTS_SUCCESS:
            return getAgentsSuccess(state, action);
        case GET_AGENTS_FAIL:
            return getAgentsFail(state, action);
        case CREATE_AGENT_START:
            return createAgentStart(state, action);
        case CREATE_AGENT_SUCCESS:
            return createAgentSuccess(state, action);
        case CREATE_AGENT_FAIL:
            return createAgentFail(state, action);
        case GET_AGENT_DETAIL_START:
            return getAgentDetailStart(state, action);
        case GET_AGENT_DETAIL_SUCCESS:
            return getAgentDetailSuccess(state, action);
        case GET_AGENT_DETAIL_FAIL:
            return getAgentDetailFail(state, action);
        case UPDATE_AGENT_DETAIL_START:
            return updateAgentDetailStart(state, action);
        case UPDATE_AGENT_DETAIL_SUCCESS:
            return updateAgentDetailSuccess(state, action);
        case UPDATE_AGENT_DETAIL_FAIL:
            return updateAgentDetailFail(state, action);
        case OPEN_AGENT_EDIT:
            return openAgentEdit(state, action);
        case CLOSE_AGENT_EDIT:
            return closeAgentEdit(state, action);
        case OPEN_AGENT_PRODUCT_ADD:
            return openAgentProductAdd(state,action);
        case CLOSE_AGENT_PRODUCT_ADD:
            return closeAgentProductAdd(state,action);
        case OPEN_AGENT_PRODUCT_EDIT:
            return openAgentProductEdit(state,action);
        case CLOSE_AGENT_PRODUCT_EDIT:
            return closeAgentProductEdit(state,action);
        case SET_LAST_REPORTED_DATE:
            return setLastReportedDate(state,action);
        default:
            return state;
    }
}

export default agentReducer;